module.exports = __webpack_public_path__ + "favicon.svg?2d54354f33c45554861192e19ec54040";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dist/favicon.svg
// module id = 404
// module chunks = 1